/** Landing site homepage URL. */
export function getLandingHomeUrl(): string {
  const base = import.meta.env.VITE_LANDING_URL ?? 'https://courtsync.io';
  return base.replace(/\/$/, '');
}

/** Landing site contact form URL (static export uses trailing slash). */
export function getLandingContactUrl(): string {
  return `${getLandingHomeUrl()}/contact/`;
}
